import(/* webpackMode: "eager" */ "/workspace/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Geist\",\"arguments\":[{\"variable\":\"--font-geist-sans\",\"subsets\":[\"latin\"]}],\"variableName\":\"geistSans\"}");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Geist_Mono\",\"arguments\":[{\"variable\":\"--font-geist-mono\",\"subsets\":[\"latin\"]}],\"variableName\":\"geistMono\"}");
;
import(/* webpackMode: "eager" */ "/workspace/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Plus_Jakarta_Sans\",\"arguments\":[{\"variable\":\"--font-jakarta\",\"subsets\":[\"latin\"],\"weight\":[\"400\",\"500\",\"600\"]}],\"variableName\":\"plusJakartaSans\"}");
;
import(/* webpackMode: "eager", webpackExports: ["ClientProvider"] */ "/workspace/src/app/client-provider.tsx");
;
import(/* webpackMode: "eager" */ "/workspace/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["VerifyEmailBanner"] */ "/workspace/src/components/auth/VerifyEmailBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DeploymentGuard"] */ "/workspace/src/components/DeploymentGuard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorBoundary"] */ "/workspace/src/components/ErrorBoundary.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/layout/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/layout/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/workspace/src/components/layout/MobileTabBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NativeApp"] */ "/workspace/src/components/NativeApp.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/workspace/src/components/ui/toaster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CurrencyProvider"] */ "/workspace/src/context/CurrencyContext.tsx");
